module.exports = "<div class=\"ribbon-content\"> <div class=\"background\" [style.background-color]=\"backgroundColor\"><div class=\"content animated fadeIn\"> <div class=\"layout-column layout-align-center-center h-100\"><span [style.color]=\"color\"><strong>{{ message }}</strong></span></div></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/ribbon-message/ribbon-message.component.pug
// module id = 634
// module chunks = 0